export const routes = {
    user: {
        GET_SITE_SETTINGS: 'api/site-settings',
        WALLET_BALANCE: 'api/user-info',
        AUTH_REFRESH: 'api/auth-refresh',
        LOGIN_API:'api/user-login',
        DEMO_LOGIN_API:'api/demo-user',
        LOGOUT_API:'api/logout',
        GET_FAVOURITE_LIST:'api/favorite-list',
        GET_EVENT_EXPOSURES: 'api/get-event-book-and-fancy-exposures-by-event-id/:matchId',
        OPEN_BETS_EVENT_LISTING: 'api/open-bets-event-listing',
        GET_OPEN_BETS: 'api/get-open-bets',
        SAVE_BETS: 'api/save-bet',
        BET_CASHOUT: 'api/cashout',
        GET_FANCY_BOOK: 'api/get-fancy-book',
        MAKE_FAVOURITE: 'api/make-event-favorite',
        CHANGE_STAKE_VALUES: 'api/change-stake-values',
        GET_WALLET_GETWAY: 'api/get-payment-getway-iframe-url',
        GET_PAYMENT_WALLET_GETWAY :'api/get-payment-getway-token',
        GET_CASINO_GAMES: 'api/get-casino-games',
        GET_MY_MARKETS: 'api/get-my-markets/:sport_type',
        GET_PREMIUM_FANCY_URL: 'api/get-sap-premium-url/:sportId/:eventId',
        GET_LOCKED_EARNED_BONUS: 'api/get-locked-earn-bonus',
        GET_BONUS_SETTINGS: 'api/get-bonus-settings',
        UPDATE_WALLET_TYPE: 'api/wallet-switch',
        GET_BONUS_LOGS: 'api/get-bonus-log',
        SEND_OTP: 'api/send-otp',
        LOGIN_WITH_OTP: 'api/login-with-otp',
        REGISTER: 'api/registration',
        GET_PROFIT_LOSS_MATCH_DETAIL: 'api/get-user-match-statements',
        GET_PROFIT_LOSS_PL_DETAIL: 'api/get-user-pl-statements',
        FORGOT_PASSWORD: 'api/reset-forgot-password',
        CHANGE_MY_PASSWORD: 'api/change-my-password',
        GET_SITE_VERSION: 'api/site-status-version',
        GET_MATKA_SINGLE_BETS: 'api/get-matka-single-bets/:id',
        SAVE_WORLI_MATKA_BET: 'api/save-worli-matka-bet',
        GET_STATEMENTS: 'api/get-statements',
        GET_PROFIT_LOSS: 'api/get-user-pl-info',
        GET_PROFIT_LOSS_DETAIL: 'api/get-profit-loss-detail',
        GET_MARKET_BETS: 'api/get-market-bets',
        GET_LIVE_POCKER_URL: 'api/get-live-poker-url/:game_code',
        DREAM_CASINO: 'api/dreamcasino/load-game/:game_code/:sm_id',
        UNIVERSE_CASINO: 'api/universe/',
        ACTIVITY_LOG:'api/activity-logs',
        GET_REFER_CODE : 'api/get-refer-code',
        // SEARCH API
        SEARCH: 'api/search',
        // NOTIFIICATIONS
        NOTIFICATIONS_LIST: 'get/all/notification/history',
        MARK_ALL_NOTIFICATION_READ: '/mark-all-as-read',
        // RULES
        GET_SITE_RULES: 'api/get-site-rules',
        // CHAT API
        GET_CHATBOT_IFRAME: 'api/chatbot/get-iframe-url',
        GET_CHATBOT_IFRAME_GUEST: 'api/chatbot/get-iframe-url-for-guest',
        GET_SPORTS_BOOK_URL : 'api/get-sap-sportsbook-url',
        // MARKET BOOK
        GET_ALL_MARKET_BOOK: 'api/get-all-event-book-and-fancy-exposures-by-event-id',

        GET_THIRD_PARTY_API: 'api/load-third-party-url',
        GET_SEARCH_EVENTS: 'api/searching-event/:searchKey',
        GET_ID_WALLET_WITHDRAW:'api/get-id/wallet-withdraw',
        GET_AUTO_UTR :'/api/wallet/get-auto-utr',

        // reedem bonus
        CLAIM_BONUS: 'api/claim-bonus',
        GET_USER_INFO : 'api/get-user-info',
        GET_STATEMENT_INFO: 'api/get-statements-info',

        //AFFILIATE
        GET_AFFILIATE_DASHBOARD: 'api/get-affiliate-dashboard',
        GET_AFFILIATE_USERSLIST: 'api/get-affiliate-user-lists',
        GET_PROFIT_LOSS_EVENT_USERS: 'api/get-affiliate-profit-loss-events',
        AFFILIATE_REGISTER: 'api/add-user',
        GET_AFFILIATE_REGISTER_USER_COUNT: 'api/get-affiliate-registered-users-count',
        GET_PAYMENT_WALLET_GETWAY :'api/get-payment-getway-token',
        GET_ID_WALLET_WITHDRAW:'api/get-id/wallet-withdraw',
        UPDATE_USER_NAME: 'api/update-display-name',
    },

    wallet: {
        //Config
        GET_WALLET_CONFIG :'client/config',
        UPDATE_TXN_PASSWORD: 'client/update-txn-password',
        // Deposit
        PARENT_PAYMENT_METHODS :'client/accounts-master-list',
        UPLOAD_AND_FETCH_QR_DATA: '/dir/settings/getSignedUrl',
        WALLET_DEPOSIT :'client/client-account-transaction',
        PAYMENT_GATEWAY :'client/payment-url',
        // Withdraw , Deposit
        CHANGE_STAKE_VALUES :'api/user/stakes/create',
        // Withdraw
        ADD_ACCOUNT :'client/create-client-account',
        ACCOUNT_DETAILS :'client/client-account',
        DELETE_ACCOUNT :'client/delete-client-account/:accountId',
        WITHDRAW_PAYLOAD_ENCRYPT_REQUEST: '/client/client-withdrawal-request',
        // History
        WALLET_HISTORY :'client/client-account-transaction',
        CANCEL_REQUEST :'client/cancel-transaction-request/:transactionId',
        SENT_OTP_TO_MOBILE :'client/transaction-password/send-otp',
        RESET_WITHDRAWAL_PASSWORD :'client/transaction-password/verify-otp',
    },
    
    sports: {
        MATCHES_BY_SPORT_ID: 'v1/events/matches/:sport_id',
        GET_SPORTS: 'v1/sports/management/getSport',
        GET_MATCH_DETAILS: 'v1/events/matchDetails/:event_id',
        FIND_BY_IDS: 'v1/events/findByIds/?eventIds=:eventIds',
        INPLAY_MATCHES_COUNT: "v1/events/count",
        GET_MATKAS: '/v1/worli/public/matches',
        GET_MATKA_MARKETS: '/v1/worli/public/matches/:id/all/markets',
        GET_UPCOMING_SPORTS:'v1/events/sports/:type',
        INPLAY_MATCHES_LIST :'v1/events/matches/inplay',
        MATCHES_LIST: 'v1/events/sports',
        MATCHES_LIST_SPORTID: 'v1/events/sports/:sport_id',
        // GET_MATKA_SINGLE_BETS: '/get-matka-single-bets/:id'
    },
    fantasy: {
        FANTASY_SETUP_DATA: '/get-setup-data',
        GET_REMEMBERED_MATCHES: '/get-remembered-matches',
        ADD_MATCH_REMINDER: '/add-match-reminder',
        REMOVE_MATCH_REMINDER: '/remove-match-reminder',
        PLAYERS_LIST_API: '/get-match-players-list/:matchId',
        GET_MY_STAKES: '/get-my-stakes',
        UPDATE_MY_STAKES: '/update-my-stakes',
        ADD_MY_TEAM: '/add-my-team',
        UPDATE_MYTEAM_NAME: '/update-my-teamname',
        BET_DETAILS: '/get-match-bet-details',
        PLACE_BET: '/place-bet',
        MY_CONTESTS_LIST: '/get-my-contests',
        MY_CONTEST_BET_LIST: '/get-match-teams-and-bet-details',
        CANCEL_BET: '/cancel-bet',
        GET_TEAM_DETAILS: '/get-team-details/:id',
        RESET_MYTEAM: '/reset-my-team',
        MATCHES_LIST_API :'/get-matches-list',
        TUTORIALS_API :'/get-tutorials',
        RULES_API: '/get-rules',
    },
    bonus: {
        GET_BONUS_LOGS: 'api/v1/get-bonus-log',
        GET_LOCKED_EARNED_BONUS: 'api/v1/get-locked-earn-bonus',
        GET_BONUS_SETTINGS: 'api/get-bonus-settings',
    },
    notification: {
        NOTIFICATIONS_LIST_API: 'api/get-notification',
        UNREAD_NOTIFICATION_COUNT: 'api/get-unread-notifications-count',
        READ_NOTIFICATION: 'api/notification/read/:userId',
        SUBSCRIBE_NOTIFICATION: 'api/subscribe-notification'
    },
    walletConfig: {
        CHANGE_STAKE_VALUES :'api/user/stakes/create',
        GET_STAKES :'api/user/stakes/list',
        BANK_DETAILS :'api/agent/bank-list',
        ONLY_BANK_STATUS :'api/user/withdrawal-only-bank-status',
    },
    walletRequest: {
        WALLET_DEPOSIT :'api/user/deposit-request',
        CANCEL_REQUEST :'api/user/cancel-request',
    }
};